<template>

	<header class="header-wrapper header-layout1">
		<div class="header-top bg-title py-2 d-none d-md-block">
			<div class="container container-style1 py-1">

				<div class="row justify-content-center justify-content-xl-between">
					<div class="col-auto d-none d-xl-block">
						<ul class="head-top-links text-end">
							<li v-if='phone=="false"'>
								<ul class="header-social">
									<li>
										<a href="#/pages/login">
											<span class="ro-header-btn">
												<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>登陆
											</span>
										</a>
									</li>
									<li>
										<a href="#/home/register">
											<span class="ro-header-btn">
												<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>注册
											</span>
										</a>
									</li>
								</ul>
							</li>
							<li v-if='phone=="false"'>
								<a href="#/home/forget">
									<span class="ro-header-btn">
										<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>忘记密码？
									</span>
								</a>
							</li>
							<li v-if='phone!="false"'>

								< <a style="color:#07ccec;">
									<el-dropdown trigger="click">
										<span class="el-dropdown-link" style="margin-left: 20px;">
											<i class="fal fa-user ro-round-icon"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<a href="#/finish_order">
												<el-dropdown-item>我的首页</el-dropdown-item>
											</a>
											<a href="#/user/order">
												<el-dropdown-item>我的订单</el-dropdown-item>
											</a>
											<a @click="log_out()">
												<el-dropdown-item>退出</el-dropdown-item>
											</a>
										</el-dropdown-menu>
									</el-dropdown>
									</a>
									<a style="color:#07ccec;">
										<el-dropdown trigger="click">
											<span
												style="margin-left: 20px;background: orange;padding:8px 20px;border-radius: 3px;color:white;font-weight: 800;">
												<i class="el-icon-shopping-cart-full" style="font-size: 20px;"></i>
												购物车({{shopcart_qty}})
											</span>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item v-for="(item,index) in shopcart"
													style="border-bottom: 1px solid #cdcdcd;overflow: hidden;padding:5px 20px;">
													<img :src="item.image" style="width: 80px;height:50px;float:left" />
													<div
														style="width: 80px;float:left;line-height: 50px;text-align: center;">
														{{item.name}}
													</div>
													<div
														style="width: 80px;float:left;line-height: 50px;text-align: center;">
														{{item.price}}元
													</div>
													<div
														style="width: 40px;float:left;line-height: 50px;text-align: center;">
														X{{item.qty}}
													</div>
												<!-- 	<div
														style="width: 80px;float:left;line-height: 50px;text-align: center;color:red">
														删除
													</div> -->

												</el-dropdown-item>
												<div style="width: 100%;padding:5px 20px;">
													<span style="float: left;font-size: 12px;line-height: 20px;">
														<div>共{{shopcart_qty}}件商品</div>
														<div style="font-size:20px;color:orangered">{{shopcart_total}}<span
																style="font-size:12px;">元</span></div>
													</span>
													<a href="#/finish_order">
														<el-button style="float: right;margin-top: 8px;" type="warning"
															size="small">去购物车结算</el-button>
													</a>
												</div>
											</el-dropdown-menu>
										</el-dropdown>
									</a>
							</li>

						</ul>
					</div>
					<!-- <div class="col-auto d-none d-xl-block" v-if="user_id">
						<ul class="head-top-links text-end">
							
							<li>
								<a href="#/user/index">
									<span class="ro-header-btn">
										<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>个人中心
									</span>
								</a>
							</li>
						</ul>
					</div> -->
				</div>
			</div>
		</div>
		<div class="sticky-wrap">
			<div class="sticky-active">
				<div class="header-main">
					<div class="container container-style1 position-relative">
						<div class="row align-items-center justify-content-between">
							<div class="col-auto">
								<div class="header1-logo py-2" style="line-height: 80px;">

<!-- 									<a href="https://www.nmgkjcx.cn/#/" style="color:#333">
										<div style="margin-left: 20px;font-size: 23px;float: left;line-height: 70px;">
											<span style="padding:0 5px;">骐众数据检索系统</span>
										</div>
									</a> -->
									
									<a href="#/" style="color:#333">
										<div style="margin-left: 20px;font-size: 23px;float: left;line-height: 70px;">
											<span style="padding:0 5px;background-color: rgb(50, 204, 255);color: white">宣传栏</span>
										</div>
									</a>
								</div>
							</div>

							<div class="col-auto d-none-xxxl">

								<div class="header-call phone-box d-flex align-items-center style2">
									<!-- 未登录状态下 -->
									<a href="tel:xxxx" class="box-icon">
										<i class="fas fa-phone-alt"></i>
									</a>
									<div class="media-body" style="text-align: left;">
										<span class="fs-xs text-title">咨询电话</span>
									</div>
									<!-- 已登录状态下 -->
									<!-- <a href="#/user/notice" v-if='phone!="false"'>
										<div
											style="border:1px solid #07ccec;padding:5px 20px;color:#07ccec;border-radius: 5px;font-size: 12px;text-align: left;line-height: 15px;">
											个人中心<br />
											Presonal Center
										</div>
									</a> -->
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>
<script>
	import {
		fetchPost
	} from "@/utils/request"
	export default {

		name: "roheader",
		props: ['shopcart','shopcart_qty','shopcart_total'],
		data: function() {
			return {

				// shopcart:[],
				// user_id: localStorage.getItem('user_id'),
				// phone: localStorage.getItem('phone'),
			};
		},
		created:function(){
				// this.get_update_message()
		},
		watch: {
		  get_shopcart(newValue) {
			  // debugger
		    this.$emit('data-updated-shopcart', newValue);
		  },
		  get_shopcart_qty(newValue) {
		  			  // debugger
		    this.$emit('data-updated-shopcart', newValue);
		  },
		  get_shopcart_total(newValue) {
		  			  // debugger
		    this.$emit('data-updated-shopcart', newValue);
		  },
		},
		computed: {
			phone: function() {
				// console.log(localStorage.getItem('phone'))
				return localStorage.getItem('phone')
			},
			// shopcart_qty: function() {
			// 	var shopcart = localStorage.getItem('shopcart');
			// 	if (shopcart == '') {
			// 		shopcart = [];
			// 	}
			// 	shopcart = JSON.parse(shopcart)
			// 	var shopcart_qty = 0
			// 	for (var i = 0; i < shopcart.length; i++) {
			// 		shopcart_qty += shopcart[i].qty
			// 	}
			// 	return shopcart_qty
			// },

		},
		methods: {
			// get_shopcart() {
			// 	var shopcart = localStorage.getItem('shopcart');
			// 	if (shopcart == '') {
			// 		shopcart = [];
			// 	}
			// 	else{
			// 		shopcart = JSON.parse(shopcart)
			// 	}
			// 	var shopcart_qty = 0
			// 	var shopcart_total = 0
			// 	for (var i = 0; i < shopcart.length; i++) {
			// 		shopcart_qty += shopcart[i].qty
			// 		shopcart_total+=shopcart[i].total
			// 	}

			// 	this.shopcart = shopcart
			// 	this.shopcart_qty = shopcart_qty
			// 	this.shopcart_total = shopcart_total
			// },
			// get_update_message() {
			// 	var data = {
			// 		'id': localStorage.getItem('eshop_user_id'),
			// 	}
			// 	var self = this
			// 	fetchPost('/ro/web_eshop/get_update_message/v1', data).then(response => {
			// 		if(response.data.update_message!='no_message'){
			// 			alert(response.data.update_message)
			// 		}
			// 	})
			// },

			log_out() {
				localStorage.setItem('phone', false)
				localStorage.setItem('eshop_user_id', false)
				localStorage.setItem('eshop_session_id', false)
				localStorage.setItem('eshop_livechat_token', false)
				localStorage.setItem('shopcart', [])
				window.location.reload()
				// this.$router.push("/pages/login")
			}

		}
	};
</script>

<style>
	@import url("../../static/css/css2.css");
	@import url("../../static/css/app.min.css");
	@import url("../../static/css/fontawesome.min.css");
	@import url("../../static/css/animate.min.css");
	@import url("../../static/css/style.css");

	.ro-header-btn {
		font-size: 12px;
		text-align: center;
		padding: 3px 10px;
		border-radius: 5px;
		border: 1px solid white;
	}

	.ro-round-icon {
		margin-right: 5px;
		background-color: white;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		line-height: 25px;
		text-align: center;
	}

	.item {
		margin-top: 0px;
		margin-right: 20px;
	}

	.el-badge__content {
		border: none !important;
	}

	.el-badge__content.is-fixed {
		transform: translateY(-20%) translateX(90%);
	}
</style>
